import { Scene } from 'dragonmouse-shared/interfaces';
import { updateGuestScenes } from '../../redux/db/actions';
import store from '../../redux/store';
import { VITE_FORGE_URL } from '../../constants';
import { SceneRow } from '../types';
import { parsePostgresDate } from '../util';
import { Stream } from './Stream';
import { v4 as uuid } from 'uuid';

export class GuestScenesStream extends Stream<SceneRow> {
	constructor(userId: string) {
		const url = VITE_FORGE_URL + '/electric/guest-scenes';
		const params = {
			userId,
			shapeBust: uuid(),
		};
		const onError = (error: Error) => {
			console.error('Guest scenes stream error:', error);
			store.dispatch(updateGuestScenes([]));
		};

		super(url, params, onError, 'guest.scenes');
	}

	onShapeData(rows: SceneRow[]) {
		const scenes: Scene[] = rows.map((sceneRow) => ({
			id: sceneRow.id,
			title: sceneRow.title,
			description: sceneRow.description,
			metadata: sceneRow.metadata,
			createdAt: parsePostgresDate(sceneRow.created_at),
			writeId: sceneRow.write_id,
			viewOnly: true,
		}));
		store.dispatch(updateGuestScenes(scenes));
	}

	onStreamMessages(_messages: Array<unknown>) {
		// No optimistic updates needed for guest scenes (read-only)
	}
}
